module.exports = __webpack_public_path__ + "img/ACWY.3c805714.png";